import pageLoadingActionTypes from '../actionTypes/pageLoadingActionTypes';

const pageLoadingActions = {
  setIsPageLoading: (payload) => ({ type: pageLoadingActionTypes.SET_IS_PAGE_LOADING, payload }),
};

export default pageLoadingActions;
